import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-event-info-article',
  standalone: true,
  imports: [CommonModule, BypassSecurityPipe],
  templateUrl: './event-info-article.component.html',
  styleUrls: ['./event-info-article.component.less']
})
export class EventInfoArticleComponent {
  @Input() data: any;
}
